import { createAction, props } from '@ngrx/store';
import { EmployeeHomeAddressRequest, EmployeeHomeAddressResponse } from '../models/employee-home-address.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';


// GET
export const loadEmployeeHomeAddress = createAction(
  '[EmployeeHomeAddress] Load',
  props<{ employeeId: string }>()
);

export const loadEmployeeHomeAddressSuccess = createAction(
  '[EmployeeHomeAddress] Load Success',
  props<{ response: EmployeeHomeAddressResponse }>()
);

export const loadEmployeeHomeAddressFailure = createAction(
  '[EmployeeHomeAddress] Load Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);


//POST
export const postEmployeeHomeAddress = createAction(
  '[EmployeeHomeAddress] Post',
  props<{ employeeId: string; request: EmployeeHomeAddressRequest }>()
);

export const postEmployeeHomeAddressSuccess = createAction(
  '[EmployeeHomeAddress] Post Success',
  props<{ response: EmployeeHomeAddressResponse }>()
);

export const postEmployeeHomeAddressFailure = createAction(
  '[EmployeeHomeAddress] Post Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
export const putEmployeeHomeAddress = createAction(
  '[EmployeeHomeAddress] Put',
  props<{ employeeId: string; request: EmployeeHomeAddressRequest }>()
);

export const putEmployeeHomeAddressSuccess = createAction(
  '[EmployeeHomeAddress] Put Success',
  props<{ response: EmployeeHomeAddressResponse }>()
);

export const putEmployeeHomeAddressFailure = createAction(
  '[EmployeeHomeAddress] Put Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);